<template>
	<c-modal @close="close" :title="'Factuur genereren'">

		<div class="text-wrap">
            <c-form ref="form" @valid="submit" class="margin-t-40">

                <c-select
                    label="Jaar"
                    :horizontal="true"
                    :options="yearOptions"
                    v-model="year"
                    name="year"
                    :ValueName="'id'"
                    DisplayName="name">
				</c-select>
                
                <c-select
                    label="Maand"
                    :horizontal="true"
                    :options="months"
                    v-model="month"
                    name="month"
                    :ValueName="'value'"
                    DisplayName="name">
				</c-select>

                <div class="flex">
                    
                    <div class="row collapse">
                        <div class="columns shrink">
                            <c-button class="margin-t-32 margin-b-16 no-margin-b" @click="generateInvoice()">Download factuuroverzicht</c-button>
                        </div>
                    </div>

                    <div class="row collapse margin-r-8">
                        <div class="columns shrink">
                            <c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">Download bijlage</c-button>
                        </div>
                    </div>

                </div>
                
            </c-form>

		</div>
	</c-modal>
</template>

<script>
import CModal from '@components/Modal';
import Form from '@mixins/Form';
import { ValidationError } from '@app/errors';

export default {
	mixins: [Form],
	components: {
		CModal
	},
    data() {
        return {
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            months: [
                {value: 1, name: 'Januari'},
                {value: 2, name: 'Februari'},
                {value: 3, name: 'Maart'},
                {value: 4, name: 'April'},
                {value: 5, name: 'Mei'},
                {value: 6, name: 'Juni'},
                {value: 7, name: 'Juli'},
                {value: 8, name: 'Augustus'},
                {value: 9, name: 'September'},
                {value: 10, name: 'Oktober'},
                {value: 11, name: 'November'},
                {value: 12, name: 'December'}
            ]
        }
    },
	props: {

	},
	methods: {
		close() {
			this.$emit('close');
		},
        submit() {
            const link = document.createElement('a');
            link.href = '/api/' + this.$route.params.id + '/invoices?year=' + this.year + '&month=' + this.month;
            document.body.appendChild(link);
            link.click();
        },
        generateInvoice() {
            const link2 = document.createElement('a');
            link2.href = '/api/' + this.$route.params.id + '/invoicesOverview?year=' + this.year + '&month=' + this.month;
            document.body.appendChild(link2);
            link2.click();
        }
	},
    computed: {
		yearOptions() {
			const startYear = 2022;
			const endYear = new Date().getFullYear();
			const years = Array.from({length: endYear - startYear + 1}, (_, i) => startYear + i);
			return years.map(year => ({value: year, name: year.toString(), id: year}));
		}
	},
    mounted(){
    }
}
</script>